var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner_bg",style:({backgroundImage:'url('+_vm.src+')'})})
}
var staticRenderFns = []

export { render, staticRenderFns }